const CareerScreen = () => {

    return(
        <p>Career Screen</p>
    )
}

export default CareerScreen